import {
  AITagMapping,
  AITagMaster,
  AnalysisProgress,
  EffectivenessTag,
  PreviewProduct,
  TagGeneration,
  TagGenerationCurrent
} from '@/common/model/recommend/aiTag'

export const AiTagApiPath = {
  LIST_AI_TAGS: '/api/sites/{site_id}/ai-tags', // GET List Ai Tags
  GET_AI_TAG: '/api/sites/{site_id}/ai-tags/{tag_id}', // GET Get Ai Tag
  CREATE_AI_TAG: '/api/sites/{site_id}/ai-tags', // POST Create Ai Tag
  GET_TAG_MAPPINGS: '/api/sites/{site_id}/ai-tags/{tag_id}/mappings', // GET Get Tag Mappings
  START_AI_ANALYSIS: '/api/sites/{site_id}/ai-tags/analyze', // POST Start Ai Analysis
  GET_AI_TAGS_PROGRESS: '/api/sites/{site_id}/ai-tags/progress', // GET Get Analysis Progress
  GET_TAG_EFFECTIVENESS: '/api/sites/{site_id}/ai-tags/effectiveness', // GET Get Tag Effectiveness
  DELETE_ALL_AI_TAGS: '/api/sites/{site_id}/ai-tags/all', // DELETE Delete All Ai Tags
  PREVIEW_TAG_PRODUCTS: '/api/sites/{site_id}/ai-tags/{tag_id}/preview', // GET Preview Tag Products
  UPDATE_AI_TAG: '/api/sites/{site_id}/ai-tags/{tag_id}', // PUT Update Ai Tag
  DELETE_AI_TAG: '/api/sites/{site_id}/ai-tags/{tag_id}', // DELETE Delete Ai Tag
  START_DIFF_ANALYSIS: '/api/sites/{site_id}/ai-tags/analyze-diff', // POST Start Diff Analysis
  LIST_TAG_GENERATIONS: '/api/sites/{site_id}/ai-tags/generations', // GET List Tag Generations
  RESTORE_TAG_GENERATION: '/api/sites/{site_id}/ai-tags/generations/{generation_id}/restore' // POST Restore Tag Generation
}

export type AiTagApiPath = (typeof AiTagApiPath)[keyof typeof AiTagApiPath]

export interface ListAiTagsVars {
  site_id: number
  page?: number
  per_page?: number
  search?: string
  category?: string
  sort_by?: string
  sort_order?: string
}

export interface GetAiTagVars {
  site_id: number
  tag_id: number
}

export interface CreateAiTagVars {
  site_id: number
  tag_name: string
  tag_category: string
  importance_score?: number
}

export interface GetTagMappingsVars {
  site_id: number
  tag_id: number
}

export interface StartAiAnalysisVars {
  site_id: number
}

export interface GetAiTagsProgressVars {
  site_id: number
}

export interface GetTagEffectivenessVars {
  site_id: number
}

export interface DeleteAllAiTagsVars {
  site_id: number
}

export interface PreviewTagProductsVars {
  site_id: number
  tag_id: number
}

export interface UpdateAiTagVars {
  site_id: number
  tag_id: number
  status?: string | null
  tag_name?: string | null
  tag_category?: string | null
  importance_score?: number | null
}

export interface DeleteAiTagVars {
  site_id: number
  tag_id: number
}

export interface StartDiffAnalysisVars {
  site_id: number
}

export interface ListTagGenerationsVars {
  site_id: number
}

export interface RestoreTagGenerationVars {
  site_id: number
  generation_id: number
}

export interface ListAiTagsResponse {
  total: number
  page: number
  per_page: number
  categories: string[]
  tags: AITagMaster[]
}

export interface GetTagMappingsResponse {
  tag_id: number
  mappings: AITagMapping[]
}

export interface StartAiAnalysisResponse {
  status: string
  message: string
}

export type GetAiTagsProgressResponse = AnalysisProgress

export interface GetTagEffectivenessResponse {
  tags: EffectivenessTag[]
  total: number
}

export interface DeleteAllAiTagsResponse {
  deleted: number
}

export interface PreviewTagProductsResponse {
  tag_id: number
  tag_name: string
  tag_category: string
  related_tags: { id: number; name: string; score: number }[]
  products: PreviewProduct[]
  total: number
}

export type GetAiTagResponse = AITagMaster

export type CreateAiTagResponse = AITagMaster

export type UpdateAiTagResponse = AITagMaster

export interface DeleteAiTagResponse {
  deleted: boolean
}

export type StartDiffAnalysisResponse = StartAiAnalysisResponse

export interface ListTagGenerationsResponse {
  current: TagGenerationCurrent | null
  generations: TagGeneration[]
}

export interface RestoreTagGenerationResponse {
  status: string
  tag_count: number
  from_generation: number
  created_at: string
}
